// 分享連結的期限選項與總表的純邏輯（SPEC #vms-web-540「分享的期限、收件人與浮水印」「分享連結總表」；platform#62、app/vms#17）。

/** 固定選項：1 小時、1 天、7 天、30 天（伺服器收 1 小時–30 天）。 */
export const SHARE_TTLS = [3600, 86400, 7 * 86400, 30 * 86400];

export interface TtlOption {
  seconds: number;
  /** 「到匯出包到期」那個選項 */
  untilExport?: boolean;
}

/**
 * 期限選項：匯出包有到期時間時，只列短於剩餘時間的固定選項，最後加「到匯出包到期」；
 * 剩不到 1 小時回空陣列（伺服器會回 EXPORT_EXPIRES_SOON，畫面直接說要重新匯出）。沒有到期時間 = 全部固定選項。
 */
export function ttlOptions(expireAt: string | undefined, nowMs: number): TtlOption[] {
  if (!expireAt) return SHARE_TTLS.map((seconds) => ({ seconds }));
  const left = Math.floor((Date.parse(expireAt) - nowMs) / 1000);
  if (!Number.isFinite(left) || left < 3600) return [];
  const out: TtlOption[] = SHARE_TTLS.filter((s) => s < left).map((seconds) => ({ seconds }));
  out.push({ seconds: Math.min(left, SHARE_TTLS[SHARE_TTLS.length - 1]), untilExport: true });
  return out;
}

/** 預設期限：1 天（有的話），否則第一個。 */
export function defaultTtl(opts: TtlOption[]): number {
  return (opts.find((o) => o.seconds === 86400 && !o.untilExport) ?? opts[0])?.seconds ?? 86400;
}

export type ShareStatus = 'active' | 'expired' | 'revoked' | 'used_up';

/** 狀態膠囊的樣式：有效的綠、次數用完的黃，其他灰。 */
export function statusClass(s: ShareStatus): string {
  return s === 'active' ? 'badge badge-ok' : s === 'used_up' ? 'badge badge-warn' : 'badge';
}

/** 觀看次數：N／上限；沒上限寫「不限」（unlimited 由呼叫端給在地字串）。 */
export function viewsText(views: number, max: number | undefined, unlimited: string): string {
  return `${views}／${max ?? unlimited}`;
}
